import type { Shape } from '~/types/grid.types'
import { ENGRAVED_2X2_SQUARE_SHAPES } from './shapesEngraved2x2Square'

// Reuse the existing engraving geometry, orientation menu and placement system.
const patterns = ['LargeParallel', 'Tangent', 'Zen', 'Offset', 'River', 'Topo', 'Converge', 'Subway']
export const LAYERED_ENGRAVED_SHAPES: Shape[] = patterns.map(pattern => {
  const source = ENGRAVED_2X2_SQUARE_SHAPES.find(shape => shape.prefix === pattern)!
  const convert = (shape: Shape): Shape => ({
    ...shape,
    id: shape.id.replace(/^Engraved/, 'LayeredEngraved'),
    prefix: `Layered${pattern}` as Shape['prefix'],
    label: `${shape.label} · 18 mm (set of 8)`,
    finishFamily: 'layered-engraved',
    admin: true,
    quantity: 8,
    depthMm: 18,
    physicalWidthIn: 23.75,
    physicalHeightIn: 23.75,
    children: shape.children?.map(convert),
  })
  return convert(source)
})
